import { Navigate, Outlet } from "react-router-dom";
import Interface from "./Interface";
import { useGlobalState } from "../globalState/GlobalStateProvider";

// Layout persistente: renderiza Topbar/Sidebar uma única vez e troca apenas o
// conteúdo pelo <Outlet/>. Assim a Sidebar não remonta ao navegar e o scroll
// do menu é preservado nativamente pelo DOM.
const MainLayout = () => {
  const { state } = useGlobalState();

  // Sem usuário logado (ex.: após logout, acesso direto a URL autenticada),
  // não há dados para Topbar/Sidebar renderizarem — manda para o login antes
  // de montar a Interface, em vez de deixá-la quebrar em state.user undefined.
  if (!state.user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Interface />
      <Outlet />
    </>
  );
};

export default MainLayout;
